import { PrimaryButton, TextField, IconButton, Panel, PanelType, DefaultButton } from '@fluentui/react';
import { Toggle as MSToggle } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { Form, Formik } from 'formik';
import React, { useState } from "react";
import ErrorComponent from '../../../Util/ErrorComponent';
import SuccessComponent from '../../../Util/SuccessComponent';
import Toggle from '../../../Forms/Toggle';
import DropDown from '../../../Forms/DropDown';
import Select from "react-select";
import { FixedSizeList as List } from "react-window";
import * as Yup from 'yup';

const dropdownOptions = [
    { key: 'default', text: 'default' },
    { key: 'spaced', text: 'spaced' },
    { key: '3month', text: '3month' },
];

const sweepstakesCadenceOptions = [
    { key: 'monthly', text: 'monthly' },
    { key: 'quarterly', text: 'quarterly' },
];

const newCoBrandSettingsObject = {
    cobrandId: null,
    accountEmails: false,
    monthlyTopicsEmail: false,
    emlSenderId: null,
    welcomeEmailTemplateId:null,
    categoryOnboardingWelcomeWhy: false,
    categoryOnboardingWelcomeCheckup: null,
    categoryOnboardingFeaturesYMP: null,
    categoryStressScoreRetake: null,
    categoryOnboardingWelcomeCheckupCadence: null,
    categoryOnboardingFeaturesYMPCadence: null,
    categorySweepstakes:false,
    categorySweepstakesCadence: 'monthly',
    categoryRecommendations: false,
    categoryRemindersCredit:false,
    customEmailPlatformName: '',
    customEmailProductName: ''
};

const validationSchema = Yup.object().shape({
    customEmailPlatformName: Yup.string()
        .max(40, 'Custom Email Platform Name must be 40 characters or less')
        .matches(
            /^[a-zA-Z0-9 .,:;!?'"&()_+/-–’™®]*$/,
            'Custom Email Platform Name can contain letters, numbers, spaces, and punctuation'
        )
        .nullable(),
    customEmailProductName: Yup.string()
        .max(40, 'Custom Email Product Name must be 40 characters or less')
        .matches(
            /^[a-zA-Z0-9 .,:;!?'"&()_+/-–’™®]*$/,
            'Custom Email Product Name can contain letters, numbers, spaces, and punctuation'
        )
        .nullable(),
});

const CustomMenuList = ({ children, ...props }) => {
    const height = 35;
    const itemCount = children.length;
    const totalHeight = Math.min(300, itemCount * height);

    return (
      <List height={totalHeight} itemCount={itemCount} itemSize={height} width="100%">
        {({ index, style }) => (
          <div
            style={{
              ...style,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              padding: "0 8px",
              boxSizing: "border-box",
            }}
            title={children[index]?.props?.children}
          >
            {children[index]}
          </div>
        )}
      </List>
    );
  };

const EmailSettings = () => {
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const [isDropdownVisible2, setIsDropdownVisible2] = useState(false);
    const [customTemplates, setCustomTemplates] = useState([]);
    const [isPanelOpen, setIsPanelOpen] = useState(false);
    const [editingTemplate, setEditingTemplate] = useState(null);
    const [panelTemplateTitle, setPanelTemplateTitle] = useState('');
    const [panelTemplateId, setPanelTemplateId] = useState('');
    const [selectedCobrandId, setSelectedCobrandId] = useState(null);

    const [{ data: senders, loading: loadingSenders }] = useAxios('/emails/email-senders');
    let sendersFormatted = senders && senders.map(u => ({ key: u.emlSenderID, text: 'Name: ' + u.fromName + ' From: ' + u.fromEmailAddress }));

    const [{ data: templates, loading: loadingTemplates }] = useAxios('/emails/email-templates');
    let templatesFormatted = templates && templates.map(u => ({ key: u.templateId, text: u.name }));

    const [{ data: cobrands, loading: loadingCobrands }] = useAxios('/internal/cobrands');
    const cobrandsOptions = cobrands && cobrands.map(u => ({ value: u.cobrandId, label: u.name }));

    const [{ data: templateTitles }] = useAxios('/emails/template-titles');
    const templateTitleOptions = templateTitles && templateTitles.map(t => ({ key: t.emlTemplateTitle, text: t.emlTemplateTitle }));

    const [{ data, loading: submitting }, submitForm] = useAxios(
        { url: `/emails/set-cobrand-email-settings` },
        { manual: true },
    );

    const [{ data: cobrandSettings, loading: loadingCobrandSettings }, fetchCobrandSettings] = useAxios(
        { url: '/emails/cobrand-email-settings-get', method: 'GET' },
        { manual: true }
    );

    const [, addCustomTemplate] = useAxios(
        { url: '/emails/custom-template', method: 'POST' },
        { manual: true }
    );

    const [, updateCustomTemplate] = useAxios(
        { url: '/emails/custom-template', method: 'PUT' },
        { manual: true }
    );

    const [, deleteCustomTemplate] = useAxios(
        { method: 'DELETE' },
        { manual: true }
    );

    const handleCobrandChange = async (option, setFieldValue) => {
        setFieldValue('cobrandId', option.value);
        setIsDropdownVisible(false);
        setIsDropdownVisible2(false);
        setSelectedCobrandId(option.value);
        
        const result = await fetchCobrandSettings({
            url: `/emails/cobrand-email-settings-get?cobrandId=${option.value}`,
        });
        
        if (!result.error) {
            const settings = result.data;
            setFieldValue('emlSenderId', settings.emlSenderId);
            setFieldValue('accountEmails', settings.accountEmails);
            setFieldValue('monthlyTopicsEmail', settings.monthlyTopicsEmail);
            setFieldValue('welcomeEmailTemplateId', settings.welcomeEmailTemplateId);
            setFieldValue('categoryOnboardingWelcomeWhy', settings.categoryOnboardingWelcomeWhy);
            setFieldValue('categoryOnboardingWelcomeCheckup', settings.categoryOnboardingWelcomeCheckup);
            setFieldValue('categoryOnboardingFeaturesYMP', settings.categoryOnboardingFeaturesYMP);
            setFieldValue('categoryStressScoreRetake', settings.categoryStressScoreRetake);
            setFieldValue('categoryOnboardingWelcomeCheckupCadence', settings.categoryOnboardingWelcomeCheckupCadence);
            setFieldValue('categoryOnboardingFeaturesYMPCadence', settings.categoryOnboardingFeaturesYMPCadence);
            setFieldValue('categorySweepstakes', settings.categorySweepstakes);
            setFieldValue('categorySweepstakesCadence', settings.categorySweepstakesCadence || 'monthly');
            setFieldValue('cobrandId', option.value);
            setFieldValue('categoryRecommendations', settings.categoryRecommendations);
            setFieldValue('categoryRemindersCredit', settings.categoryRemindersCredit);
            setFieldValue('customEmailPlatformName', settings.customEmailPlatformName);
            setFieldValue('customEmailProductName', settings.customEmailProductName);
            setCustomTemplates(settings.customTemplates || []);
        } else {
            setShowError(true);
        }
    };

    const getCobrandName = (cobrandId) => {
        const cobrand = cobrandsOptions?.find(c => c.value === cobrandId);
        return cobrand ? cobrand.label : '';
    };

    const handleAddTemplate = () => {
        setEditingTemplate(null);
        setPanelTemplateTitle('');
        setPanelTemplateId('');
        setIsPanelOpen(true);
    };

    const handleEditTemplate = (template) => {
        setEditingTemplate(template);
        setPanelTemplateTitle(template.originalEMLTemplateTitle);
        setPanelTemplateId(template.emlTemplateId);
        setIsPanelOpen(true);
    };

    const handleDeleteTemplate = async (template) => {
        if (window.confirm('Are you sure you want to delete this custom template?')) {
            const result = await deleteCustomTemplate({
                url: `/emails/custom-template/${template.emlCustomTemplate_x_Cobrand_x_LanguageId}`
            });
            if (!result.error) {
                setCustomTemplates(prev => prev.filter(t => t.emlCustomTemplate_x_Cobrand_x_LanguageId !== template.emlCustomTemplate_x_Cobrand_x_LanguageId));
                setShowSuccess(true);
            } else {
                setShowError(true);
            }
        }
    };

    const handlePanelSave = async () => {
        const cobrandName = getCobrandName(selectedCobrandId);
        const request = {
            emlTemplateId: panelTemplateId,
            originalEMLTemplateTitle: panelTemplateTitle,
            cobrandId: selectedCobrandId,
            cobrandName: cobrandName
        };

        if (editingTemplate) {
            request.emlCustomTemplate_x_Cobrand_x_LanguageId = editingTemplate.emlCustomTemplate_x_Cobrand_x_LanguageId;
            const result = await updateCustomTemplate({ data: request });
            if (!result.error) {
                setCustomTemplates(prev => prev.map(t => 
                    t.emlCustomTemplate_x_Cobrand_x_LanguageId === editingTemplate.emlCustomTemplate_x_Cobrand_x_LanguageId 
                        ? result.data 
                        : t
                ));
                setShowSuccess(true);
            } else {
                setShowError(true);
            }
        } else {
            const result = await addCustomTemplate({ data: request });
            if (!result.error) {
                setCustomTemplates(prev => [...prev, result.data]);
                setShowSuccess(true);
            } else {
                setShowError(true);
            }
        }
        setIsPanelOpen(false);
    };

    return (
<Formik
    initialValues={newCoBrandSettingsObject}
    validationSchema={validationSchema}
    onSubmit={async (values, { resetForm }) => {
        let result = await submitForm({
            url: "/emails/set-cobrand-email-settings",
            method: "POST",
            data: { ...values },
        });
        if (!result.isAxiosError) {
            setShowSuccess(true);
            setIsFormDirty(false); // Reset manual dirty flag after successful submit
        } else {
            setShowError(true);
        }
    }}
    validateOnBlur
    enableReinitialize={true}
    isInitialValid={false}
        >
            {({ values, setFieldValue, handleSubmit, isValid, handleBlur, touched, errors }) => {
        const [isFormDirty, setIsFormDirty] = useState(false);

        const handleFieldChange = (field, value) => {
            if (field !== "cobrandId") {
                setIsFormDirty(true);
            }
            setFieldValue(field, value);
        };

        return (
            <Form style={{ maxWidth: "400px", marginBottom: 500 }}>
                <div className="mt-1">
                    <Select
                        components={{ MenuList: CustomMenuList }}
                        options={cobrandsOptions}
                        placeholder="Cobrand"
                        name="cobrandId"
                        value={cobrandsOptions?.find(
                            (option) => option.value === values.cobrandId
                        )}
                        onChange={(option) => {
                            handleCobrandChange(option, setFieldValue);
                        }}
                        isSearchable
                        styles={{
                            menuList: (base) => ({
                                ...base,
                                maxHeight: "300px",
                                overflowY: "auto",
                            }),
                            container: (base) => ({
                                ...base,
                                width: 300,
                            }),
                        }}
                    />
                    <hr />
                    {values.cobrandId && (
                        <>
                            <MSToggle
                                label="Emails on"
                                onText="On"
                                offText="Off"
                                checked={values.accountEmails}
                                onChange={(e, checked) => handleFieldChange("accountEmails", checked)}
                            />
                            {values.accountEmails && (
                                <>
                                    <hr />
                                    <MSToggle
                                        label="Custom sender needed"
                                        onText="Yes"
                                        offText="No"
                                        checked={isDropdownVisible || values.emlSenderId}
                                        onChange={(e, checked) => handleFieldChange("emlSenderId", checked)}
                                    />
                                    {(isDropdownVisible || values.emlSenderId) && (
                                        <>
                                            <DropDown
                                                label="Email Sender"
                                                name="emlSenderId"
                                                options={sendersFormatted}
                                                onChange={(event, item) => {
                                                    handleFieldChange("emlSenderId", item.key);
                                                }}
                                            />
                                            <hr />
                                        </>
                                    )}
                                    <MSToggle
                                        label="Account confirmation"
                                        onText="Yes"
                                        offText="No"
                                        checked={isDropdownVisible2 || values.welcomeEmailTemplateId}
                                        onChange={(e, checked) => handleFieldChange("welcomeEmailTemplateId", checked)}
                                    />
                                    {(isDropdownVisible2 || values.welcomeEmailTemplateId) && (
                                        <DropDown
                                            label="Email Templates"
                                            name="welcomeEmailTemplateId"
                                            options={templatesFormatted}
                                            onChange={(event, item) => {
                                                handleFieldChange("welcomeEmailTemplateId", item.key);
                                            }}
                                        />
                                    )}
                                    <hr />
                                    <Toggle
                                        name="categoryOnboardingWelcomeWhy"
                                        label="Welcome why"
                                        onText="On"
                                        offText="Off"
                                        onChange={(e, checked) => handleFieldChange("categoryOnboardingWelcomeWhy", checked)}
                                    />
                                    <Toggle
                                        name="categoryOnboardingWelcomeCheckup"
                                        label="Welcome checkup drip campaign"
                                        onText="On"
                                        offText="Off"
                                        onChange={(e, checked) => handleFieldChange("categoryOnboardingWelcomeCheckup", checked)}
                                    />
                                    {values.categoryOnboardingWelcomeCheckup && (
                                        <DropDown
                                            label="Cadence"
                                            name="categoryOnboardingWelcomeCheckupCadence"
                                            options={dropdownOptions}
                                            onChange={(event, item) => {
                                                handleFieldChange("categoryOnboardingWelcomeCheckupCadence", item.key);
                                            }}
                                        />
                                    )}
                                    <Toggle
                                        name="categoryOnboardingFeaturesYMP"
                                        label="YMP drip campaign"
                                        onText="On"
                                        offText="Off"
                                        onChange={(e, checked) => handleFieldChange("categoryOnboardingFeaturesYMP", checked)}
                                    />
                                    {values.categoryOnboardingFeaturesYMP && (
                                        <DropDown
                                            label="Cadence"
                                            name="categoryOnboardingFeaturesYMPCadence"
                                            options={dropdownOptions}
                                            onChange={(event, item) => {
                                                handleFieldChange("categoryOnboardingFeaturesYMPCadence", item.key);
                                            }}
                                        />
                                    )}
                                    <Toggle
                                        name="categoryStressScoreRetake"
                                        label="Stress score retake reminder"
                                        onText="On"
                                        offText="Off"
                                        onChange={(e, checked) => handleFieldChange("categoryStressScoreRetake", checked)}
                                    />
                                    <Toggle
                                        name="categorySweepstakes"
                                        defaultChecked={values.categorySweepstakes}
                                        label="Sweepstakes alert"
                                        onText="On"
                                        offText="Off"
                                        onChange={(e, checked) => handleFieldChange("categorySweepstakes", checked)}
                                    />
                                    {values.categorySweepstakes && (
                                        <DropDown
                                            label="Cadence"
                                            name="categorySweepstakesCadence"
                                            options={sweepstakesCadenceOptions}
                                            onChange={(event, item) => {
                                                handleFieldChange("categorySweepstakesCadence", item.key);
                                            }}
                                        />
                                    )}
                                    <Toggle
                                        name="categoryRecommendations"
                                        defaultChecked={values.categoryRecommendations}
                                        label="Recommendations monthly alert"
                                        onText="On"
                                        offText="Off"
                                        onChange={(e, checked) => handleFieldChange("categoryRecommendations", checked)}
                                    />
                                    <Toggle
                                        name="categoryRemindersCredit"
                                        defaultChecked={values.categoryRemindersCredit}
                                        label="Credit score reminders"
                                        onText="On"
                                        offText="Off"
                                        onChange={(e, checked) => handleFieldChange("categoryRemindersCredit", checked)}
                                    />
                                    <Toggle
                                        name="monthlyTopicsEmail"
                                        label="Banner 1 topics monthly email"
                                        onText="On"
                                        offText="Off"
                                        onChange={(e, checked) => handleFieldChange("monthlyTopicsEmail", checked)}
                                    />
                                    <hr />
                                    <TextField
                                        label="Custom Email Platform Name"
                                        name="customEmailPlatformName"
                                        value={values.customEmailPlatformName}
                                        onChange={(e, newValue) => handleFieldChange("customEmailPlatformName", newValue)}
                                        onBlur={handleBlur}
                                        errorMessage={touched.customEmailPlatformName && errors.customEmailPlatformName}
                                    />
                                    <hr />
                                    <TextField
                                        label="Custom Email Product Name"
                                        name="customEmailProductName"
                                        value={values.customEmailProductName}
                                        onChange={(e, newValue) => handleFieldChange("customEmailProductName", newValue)}
                                        onBlur={handleBlur}
                                        errorMessage={touched.customEmailProductName && errors.customEmailProductName}
                                    />
                                    <hr />
                                    
                                    {/* Custom Emails Section */}
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '20px' }}>
                                        <h3 style={{ margin: 0 }}>Custom Emails</h3>
                                        <IconButton
                                            iconProps={{ iconName: 'Add' }}
                                            title="Add Custom Email"
                                            ariaLabel="Add Custom Email"
                                            onClick={handleAddTemplate}
                                        />
                                    </div>
                                    <div style={{ fontSize: '13px', color: '#666', marginTop: '8px', marginBottom: '8px' }}>
                                        If this cobrand has custom versions of the emails above, use this tool to select the default template to replace with the template ID of the custom email.
                                    </div>
                                    <div style={{ marginTop: '10px' }}>
                                        {customTemplates.length === 0 ? (
                                            <div style={{ color: '#666', fontStyle: 'italic' }}>No custom emails configured</div>
                                        ) : (
                                            customTemplates.map((template) => (
                                                <div 
                                                    key={template.emlCustomTemplate_x_Cobrand_x_LanguageId} 
                                                    style={{ 
                                                        display: 'flex', 
                                                        justifyContent: 'space-between', 
                                                        alignItems: 'center',
                                                        padding: '8px 0',
                                                        borderBottom: '1px solid #eee'
                                                    }}
                                                >
                                                    <div>
                                                        <div style={{ fontWeight: 500 }}>{template.originalEMLTemplateTitle}</div>
                                                        <div style={{ fontSize: '12px', color: '#666' }}>ID: {template.emlTemplateId}</div>
                                                    </div>
                                                    <div>
                                                        <IconButton
                                                            iconProps={{ iconName: 'Edit' }}
                                                            title="Edit"
                                                            ariaLabel="Edit"
                                                            onClick={() => handleEditTemplate(template)}
                                                        />
                                                        <IconButton
                                                            iconProps={{ iconName: 'Delete' }}
                                                            title="Delete"
                                                            ariaLabel="Delete"
                                                            onClick={() => handleDeleteTemplate(template)}
                                                        />
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                </>
                            )}
                        </>
                    )}
                </div>
                <SuccessComponent
                    successMessage="Email settings Updated."
                    showSuccess={showSuccess}
                    setShowSuccess={setShowSuccess}
                />
                <ErrorComponent
                    errorMessage="Errors in form, check all tabs for highlighted fields."
                    showError={showError}
                    setShowError={setShowError}
                />
                <div className='mt20'></div>
                {isFormDirty && (
                    <div style={{ display: "flex" }} className="mt-1">
                        <PrimaryButton
                            onClick={() => handleSubmit()}
                            text={"Update"}
                            disabled={!isValid || !isFormDirty}
                        />
                    </div>
                )}

                {/* Custom Template Panel */}
                <Panel
                    isOpen={isPanelOpen}
                    onDismiss={() => setIsPanelOpen(false)}
                    headerText={editingTemplate ? "Edit Custom Email" : "Add Custom Email"}
                    type={PanelType.smallFixedFar}
                >
                    <div style={{ marginTop: '20px' }}>
                        <DropDown
                            label="Template To Replace"
                            name="panelTemplateTitle"
                            options={templateTitleOptions}
                            selectedKey={panelTemplateTitle}
                            onChange={(event, item) => {
                                setPanelTemplateTitle(item.key);
                            }}
                        />
                        <TextField
                            label="Template ID (SendGrid)"
                            value={panelTemplateId}
                            onChange={(e, newValue) => setPanelTemplateId(newValue)}
                        />
                        <div style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
                            <PrimaryButton
                                text="Save"
                                onClick={handlePanelSave}
                                disabled={!panelTemplateTitle || !panelTemplateId}
                            />
                            <DefaultButton
                                text="Cancel"
                                onClick={() => setIsPanelOpen(false)}
                            />
                        </div>
                    </div>
                </Panel>
            </Form>
        );
    }}
</Formik>
    );
};
export default EmailSettings
